import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
    className?: any,
    color?: any,
    children: ReactNode,
}

const Text = (props: Props) => {
    return (
        <TextWithStyled { ...props }>
            { props.children }
        </TextWithStyled>
    )
}

const TextWithStyled = styled.span<Props>`
    color: ${({ color }) => color};
`;

export default Text;